import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { HostListener } from '@angular/core';
import { ModalScroll } from 'src/app/shared/services/api-services/modal-scroll.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/state/app.state';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { MEDICAL_UW_URL, MEDICAL_UW_HO_URL } from 'src/app/shared/constants/medical-uw-url.constants';
import { SaveReturnModel } from 'src/app/pages/medical-underwriting/model/mcUserJourney.model';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { DeviceDimensionsService } from 'src/app/shared/utilities/functionality/device-dimensions.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    imports: [NgClass]
})
export class ModalComponent implements OnInit, OnDestroy {

  @Input() modalConfig = {
    modalType: 'alert',
    header: 'A message you should pay attention to',
    content: 'Content',
    footerPrimaryBtnLabel: 'OK',
    footerSecondaryBtnLabel: 'OK',
    checkMessage: ''
  };
  @Input() saveDataFlag;
  @Input() tooltipFlag;
  @Input() isFocus = true;
  @Input() primaryLayout: boolean = false;
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() primaryBtnClick: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() secondaryBtnClick: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() dontShowUpMsgAgain: EventEmitter<boolean> = new EventEmitter<boolean>();
  isHOView = false;
  dontShowMsgAgain: boolean = false;
  public count: number = 0;
  loginDetail: any;
  btnClass:string;
  deviceType: any;
  
  @ViewChild("closeBtnHeader", { static: true }) modalBtnHeader: ElementRef;
  @ViewChild("secondaryBtn", { static: true }) secondaryBtnFoc: ElementRef;
  @ViewChild("primaryBtn", { static: true }) primaryBtnFoc: ElementRef;
  @ViewChild("closeBtn", { static: true }) closeBtnFoc: ElementRef;


  constructor(private elementRef: ElementRef, private modalScrollService: ModalScroll,
              private store: Store<AppState>, private activatedRoute: ActivatedRoute,
              private router: Router, private deviceDimensionsService: DeviceDimensionsService) {
    this.store.select(STORE_VAL.loggedin_detail).subscribe(res => {
      if (res.length > 0) {
        this.loginDetail = res[0];
      }
    });
    this.isHOView = this.router.url.includes('ho-underwriting') ? true : false;
  }

  ngOnInit() {
    this.modalScrollService.handleModalScrollFlag({ scrollModalFlag: true, btnFocus: false });
    this.setFocus();
    this.checkUrl();
    this.btnClass = this.tooltipFlag ? "btn" : "btn btn-chevron reflectChev-btn";
  }

  ngOnDestroy() {
  if(this.isFocus) {
    this.modalScrollService.handleModalScrollFlag({ scrollModalFlag: false, btnFocus: true });
   } else {
    this.modalScrollService.handleModalScrollFlag({ scrollModalFlag: false, btnFocus: false });
   }
  }

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement: HTMLElement): void {
    this.deviceType=this.deviceDimensionsService.onResize('$event');
    const modalEle = document.getElementById('modal-dialog');

    if(modalEle && targetElement.className === "modal-wrapper" && this.deviceType !== "large") {
      this.closeModal.emit(true);
    }
  }

  onClickOutside(){
    this.closeModal.emit(true);

  }

  primaryBtnClickHandler() {
    this.primaryBtnClick.emit(true);
  }

  secondaryBtnClickHandler() {
    this.secondaryBtnClick.emit(true);
  }

  close() {
    this.closeModal.emit(true);
  }

  toggleVisibility() {
    this.dontShowUpMsgAgain.emit(this.dontShowMsgAgain);
  }

  setFocus() {

    this.modalBtnHeader.nativeElement.focus();
  }
  checkUrl(): boolean {
    let currentScreen: boolean;
    // tslint:disable-next-line: max-line-length
    if (this.router.url.includes(MEDICAL_UW_URL.annuitant.DMC) || this.router.url.includes(MEDICAL_UW_URL.dependant.dependantDMC) || this.router.url.includes(MEDICAL_UW_HO_URL.annuitant.DMC) || this.router.url.includes(MEDICAL_UW_HO_URL.dependant.dependantDMC)) {
      currentScreen = true;
      return currentScreen;
    } else {
      currentScreen = false;
      return currentScreen;
    }
  }


  setCheckMessage() {
    // tslint:disable-next-line: max-line-length
    if (this.router.url.includes(MEDICAL_UW_URL.annuitant.DMC) || this.router.url.includes(MEDICAL_UW_URL.dependant.dependantDMC) || this.router.url.includes(MEDICAL_UW_HO_URL.annuitant.DMC) || this.router.url.includes(MEDICAL_UW_HO_URL.dependant.dependantDMC) ) {
      return ;
    } else {
      return ;
    }
  }

  navTo() {
    if ( this.isHOView ) {
      // tslint:disable-next-line: max-line-length
      this.router.navigate([this.router.url.includes(MEDICAL_UW_HO_URL.annuitant.DMC) ? MEDICAL_UW_HO_URL.annuitant.medicalConditions : MEDICAL_UW_HO_URL.dependant.dependantMedicalConditions]);
    } else {
      // tslint:disable-next-line: max-line-length
      this.router.navigate([this.router.url.includes(MEDICAL_UW_URL.annuitant.DMC) ? MEDICAL_UW_URL.annuitant.medicalConditions : MEDICAL_UW_URL.dependant.dependantMedicalConditions]);
    }
  }


  @HostListener('document:keydown', ['$event']) circulateTabbing(event) {

    if (!(event.shiftKey) && event.keyCode === 9) {
      if (this.count === 0) {
        this.count++;
      } else if (this.count === 4) {
        this.count = 1;
      }

      switch (true) {
        case this.count === 1: this.closeBtnFoc.nativeElement.focus();
          this.count++;
          break;

        case this.count === 2: this.primaryBtnFoc.nativeElement.focus();
          this.count++;
          break;

        case this.count === 3: this.secondaryBtnFoc.nativeElement.focus();
          this.count++;
          break;


        default: break;
      }

    }

    else if (event.shiftKey && event.keyCode === 9) {


      if (this.count === 0) {
        this.count++;
      } else if (this.count === 4) {
        this.count = 3;
      }


      switch (true) {
        case this.count === 1: this.secondaryBtnFoc.nativeElement.focus();
          this.count = 3;
          break;


        case this.count === 2: this.closeBtnFoc.nativeElement.focus();

          this.count--;
          break;

        case this.count === 3: this.primaryBtnFoc.nativeElement.focus();

          this.count--;
          break;



        default: break;
      }



    }

  }
  dontShowMessage() {
    if (!this.modalConfig.checkMessage) {
      if (this.modalConfig.footerPrimaryBtnLabel === 'Retry' &&
          (this.router.url === '/quote/your-product-options' || this.router.url === '/quote/please-confirm-your-details')) {
            return false;
          } else if (this.router.url === '/home/your-product-choice') {
            return false;
          } else {
            return true;
          }
    }
  }


}
